import {
  SystemTag,
  ContactTag,
  TagOwnershipType,
  PropertiesTag
} from '@ui/shared/model';

export function sortTags(tags: ContactTag[] | PropertiesTag[]) {
  return [...(tags || [])].sort((a, b) => {
    if (a?.tagOwnershipType === b?.tagOwnershipType) {
      return a?.title.toUpperCase() > b?.title.toUpperCase() ? 1 : -1;
    }
    return (
      Object.values(TagOwnershipType).indexOf(a.tagOwnershipType) -
      Object.values(TagOwnershipType).indexOf(b.tagOwnershipType)
    );
  });
}

export function prioritizeSystemTags(
  tags: SystemTag[],
  prioritizedTypes: SystemTag[]
): SystemTag[] {
  if (!tags?.length || !prioritizedTypes?.length) return tags;

  const present = new Set(tags);
  const prioritized = new Set(prioritizedTypes);

  return [
    ...prioritizedTypes.filter(t => present.has(t)),
    ...tags.filter(t => !prioritized.has(t))
  ];
}
